import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Pause, Play, Trash2, Zap } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { EmptyRow, Money, PageHeader, Panel } from "@/components/common";

export default function Recurring() {
  const { t } = useLang();
  const [rows, setRows] = useState([]);
  const load = () => api.get("/recurring").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const act = async (fn, msg) => { try { await fn(); if (msg) toast.success(msg); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="recurring-page">
      <PageHeader title={t("recurring")} subtitle={t("recurringSubtitle")} />
      <Panel className="overflow-x-auto">
        <table className="data-table">
          <thead><tr><th>{t("client")}</th><th>{t("fromInvoice")}</th><th>{t("dayOfMonth")}</th><th>{t("nextDate")}</th><th>{t("lastGenerated")}</th><th className="text-end">{t("total")}</th><th>{t("status")}</th><th className="text-end">{t("actions")}</th></tr></thead>
          <tbody>
            {rows.length === 0 && <EmptyRow cols={8} />}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`recurring-row-${r.id}`}>
                <td className="font-semibold">{r.client_name}</td>
                <td className="font-mono text-slate-500">{r.source_invoice}</td>
                <td className="font-mono">{r.day_of_month}</td>
                <td className="font-mono">{r.next_date}</td>
                <td>{r.last_invoice_id ? <Link to={`/invoices/${r.last_invoice_id}`} className="font-mono text-[#007A3D] hover:underline">{r.last_invoice_number}</Link> : "—"} <span className="text-xs text-slate-400">({r.runs})</span></td>
                <td className="text-end"><Money value={r.total} /></td>
                <td><span data-testid={`recurring-status-${r.id}`} className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ${r.active ? "bg-emerald-50 text-emerald-800 ring-emerald-200" : "bg-slate-100 text-slate-500 ring-slate-200"}`}>{t(r.active ? "active" : "paused")}</span></td>
                <td className="whitespace-nowrap text-end">
                  <button data-testid={`recurring-run-${r.id}`} title={t("generateNow")} onClick={() => act(() => api.post(`/recurring/${r.id}/run-now`), t("invoiceCreated"))} className="rounded p-1.5 text-slate-500 hover:bg-emerald-50 hover:text-[#007A3D]"><Zap className="h-4 w-4" /></button>
                  <button data-testid={`recurring-toggle-${r.id}`} onClick={() => act(() => api.patch(`/recurring/${r.id}/toggle`))} className="rounded p-1.5 text-slate-500 hover:bg-slate-100">{r.active ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}</button>
                  <button data-testid={`recurring-delete-${r.id}`} onClick={() => window.confirm(t("confirmDelete")) && act(() => api.delete(`/recurring/${r.id}`), t("deleted"))} className="rounded p-1.5 text-slate-500 hover:bg-red-50 hover:text-[#CE1126]"><Trash2 className="h-4 w-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
